let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5PRCb")).then(() => parcelRequire('4nbVT'));